import { CardVariant } from '@/components/card/types';
import { ChipLabel } from '@/components/chip-label';
import { DS_HEIGHT, DS_WIDTH } from '@calm/evexia-design-tokens';
import { LockFilled, PlayFilled, VideoFilled } from '@rhg/libs/material/icons';
import { sxAppend } from '@rhg/libs/material/sx';

const styleChipLabel = {
    m: 4,
};
const styleLockedChipLabel = (isLocked?: boolean) => {
    if (!isLocked) {
        return undefined;
    }
    return {
        padding: 1,
        height: 'auto',
        width: 'auto',
        '.MuiChip-label': {
            padding: 0,
        },
        '.MuiChip-icon': {
            margin: 0,
        },
    };
};

const styleChipLabelHorizontal = { m: 2 };

const styleBottomChipIcon = {
    height: DS_HEIGHT.CHIP_XSMALL,
    width: DS_WIDTH.CHIP_XSMALL,
};

export function IconBottom({
    durationText,
    isLocked,
    isVideo,
    variant,
}: {
    durationText?: string;
    isLocked?: boolean;
    isVideo: boolean;
    variant: CardVariant;
}) {
    if (variant === CardVariant.Banner || !durationText) {
        return null;
    }

    const label = isLocked ? undefined : durationText;
    return (
        <ChipLabel
            sx={sxAppend(
                styleChipLabel,
                styleLockedChipLabel(isLocked),
                variant === CardVariant.Horizontal
                    ? styleChipLabelHorizontal
                    : undefined
            )}
            variant="darkTransparent"
            label={label}
            icon={
                isLocked ? (
                    <LockFilled />
                ) : isVideo ? (
                    <VideoFilled style={styleBottomChipIcon} />
                ) : (
                    <PlayFilled style={styleBottomChipIcon} />
                )
            }
        />
    );
}
